import Session from "../helpers/SessionHelper";
import axios from "axios";

const UserReportService = {
  async getSeasonalAverages(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    const response = await axios.get(payload, {
      headers: headers,
    });
    return response;
  },
  async exportSeasonalAverages(payload) {
    if (!payload) return;
    const headers = await Session.getHeaderWithToken();
    headers.Accept = "application/vnd.ms-excel";
    const response = await axios.get(payload, {
      headers: headers,
      responseType: "blob",
      redirect: "follow",
    });
    return response;
  },
};
export default UserReportService;
